export const PURCHASE_INVOICES = 'accounting/purchase_invoices/';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const SIDE_MENU_KEY = 'sideMenu';

// price_usage
export const PRICE_USAGE_CONTRACT = 'contract'
export const PRICE_USAGE_PRICE_LIST = 'price_list'

export const SERVICE_DESK_URL = 'https://issues.belitsoft.com/servicedesk/customer/portal/10'


// WEBPACK FOOTER //
// ./src/constants/index.js